module.exports = {"422823100":"信陵镇","422823101":"东瀼口镇","422823102":"沿渡河镇","422823103":"官渡口镇","422823104":"茶店子镇","422823105":"绿葱坡镇","422823106":"大支坪镇","422823107":"野三关镇","422823108":"水布垭镇","422823109":"清太坪镇","422823200":"溪丘湾乡","422823201":"金果坪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/422823.json
// module id = 1643
// module chunks = 0